import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { MoveOrderList, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, constants } from '../utils';

export default function MoveOrders() {
   const navigate = useNavigate();
   const [data, setData] = useState({});
   const [loaded, setLoaded] = useState(false);

   useEffect(() => {
      api
         .fetch(`Transfer/GetActiveMoveOrders`)
         .then(response => {
            if (response.data.success) {
               setData(response.data.data);
            }
            else {
               setData({});
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            setData({});
         })
         .finally(() => {
            setLoaded(true);
         })
   }, [])

   function createOrder() {
      api
         .post(`Transfer/CreateMoveOrder`)
         .then(response => {
            if (response.data.success) {
               var nav = constants.ENDPOINTS.moveOrder + "/" + response.data.moveId;
               navigate(nav);
            }
            else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         })
   }

   return (
      <>
         <DesktopContainer screenName="Move Orders">
            <ServiceThreadSpinner on={!loaded}>
               <div>
                  <Row className="justify-content-center">
                     <Col xs="12">
                        <Button
                           title="item search"
                           className="shredButton w-100 btn-md my-3"
                           onClick={() => { createOrder(); }}>
                           Create Move Order
                        </Button>
                     </Col>
                  </Row>
               </div>
               <br />
               {loaded && data ?
                  <div>
                     <MoveOrderList data={data} />
                  </div>
                  : null
               }
            </ServiceThreadSpinner>
         </DesktopContainer >
      </>
   );
}
